import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateRange'
})
export class DateRangePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'recent':
        return 'Last 14 Days';
      case 'month':
        return 'This Month';
      case 'year':
        return 'This Year';
      case 'range':
        return 'Custom Range';
      default:
        return value;
    }
  }
} 